import { takeLatest, put } from 'redux-saga/effects';

import { ADMIN_LOGIN_REQUEST } from '../../actions';
import {
    adminLogin,
    adminLoginSuccess,
    adminLoginFail,
    sessionStart,
    sessionEnd
} from '../../action-creators';
import { simpleRequest } from '../modules/request';

export default takeLatest(
    ADMIN_LOGIN_REQUEST,
    simpleRequest<RT<typeof adminLogin>>({
        success: adminLoginSuccess,
        failure: adminLoginFail,
        getUrl: () => `auth-users/user_token/`,
        getBody: (action) => ({ email: action.email }),
        method: 'POST',
        onSuccess: function* (data) {
            yield put(sessionEnd());

            const { access, refresh } = data || {};
            yield put(sessionStart({ access, refresh }, { verified: true }));
            return data;
        }
    })
);
